import React from "react";
import { UserManagement } from "../features/users";
import { withRestaurantId } from "../shared/components/layout";

const UserManagementWithId = withRestaurantId(UserManagement);

const UserManagementPage: React.FC = () => {
  return <UserManagementWithId />;
};

export default UserManagementPage;
